import React from 'react';
import { Quote } from 'lucide-react';
export function ExpertQuote() {
  return <section className="px-4 mb-12" data-id="element-85">
      <div className="bg-brown/5 rounded-2xl p-8 relative" data-id="element-86">
        <Quote className="absolute top-4 left-4 text-brown/20 w-12 h-12 -rotate-6" data-id="element-87" />

        <div className="relative z-10" data-id="element-88">
          <p className="font-serif text-lg md:text-xl text-text/90 leading-relaxed italic text-center mb-6" data-id="element-89">
            "Viele Hunde leiden unter suboptimaler Nährstoffverwertung ohne dass
            es offensichtliche Symptome gibt. Eine gesunde Darmflora und
            ausreichend Ballaststoffe sind entscheidend für die effiziente
            Absorption von Vitaminen, Mineralstoffen und Proteinen."
          </p>

          <div className="flex items-center justify-center gap-4" data-id="element-90">
            <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=150&auto=format&fit=crop" alt="Dr. Nane Schomburg" className="w-14 h-14 rounded-full object-cover border-2 border-cream shadow-sm" data-id="element-91" />
            <div className="text-left" data-id="element-92">
              <p className="font-serif font-bold text-forest" data-id="element-93">
                Dr. Nane Schomburg
              </p>
              <p className="font-serif text-sm text-brown" data-id="element-94">Tierärztin</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}